import { Component, Input } from '@angular/core';
import { Observable, combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';

import { IWebcastViewContext } from 'rev-shared/webcast/webcastView/IWebcastViewContext';

import { INotifications } from 'rev-portal/scheduledEvents/webcast/Webcast.Contract';
import { WebcastModel } from 'rev-portal/scheduledEvents/webcast/model/WebcastModel';
import { orderBy } from 'rev-shared/util/SortUtil';

import { WebcastViewQuestionsService } from './WebcastViewQuestions.Service';
import { Question, QuestionContext } from './Question';

const whenModified = 'whenModified';

@Component({
	selector: 'vb-webcast-attendee-question-sidebar',
	templateUrl: './VbWebcastAttendeeQuestionSidebar.Component.html',
	standalone: false,
	styleUrls: ['./VbWebcastAttendeeQuestionSidebar.Component.ng.less', '../WebcastSidebar.ng.less'],

})
export class VbWebcastAttendeeQuestionSidebarComponent {
	@Input() public webcast: WebcastModel;
	@Input() public sidebarNotifications: INotifications;
	@Input() public context: IWebcastViewContext;

	public readonly QuestionContext = QuestionContext;
	public attendeeQuestionsContext$: Observable<any>;

	constructor(
		private readonly WebcastViewQuestionsService: WebcastViewQuestionsService
	) {}

	public ngOnInit(): void {
		this.ensureQuestionsContextLoaded();
	}

	public ngOnDestroy(): void {
		this.WebcastViewQuestionsService.unsubscribeHandlers();
	}

	public ensureQuestionsContextLoaded(): void {
		this.WebcastViewQuestionsService.subscribeAttendeeHandlers(this.webcast, this.sidebarNotifications.questions);

		this.attendeeQuestionsContext$ = combineLatest([
			this.WebcastViewQuestionsService.attendeeMyQuestions$,
			this.WebcastViewQuestionsService.attendeePublicQuestions$
		])
			.pipe(
				map(([questions, publicQuestions]) => {
					return {
						questions: orderBy(questions, q => q[whenModified], false),
						publicQuestions: orderBy(publicQuestions, q => q[whenModified], false)
					};
				})
			);
	}

	public onQuestionAsked(question: Question): void {
		this.WebcastViewQuestionsService.addAttendeeMyQuestion(question);
		const unsub = this.WebcastViewQuestionsService.applyAttendeePushHandlers([question], this.sidebarNotifications.questions);
		this.WebcastViewQuestionsService.subscribeMyNewQuestionHandler(this.webcast, unsub);
	}
}
